import { useState } from 'react';
import { Flex, Subtitle } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import { checkIdValid } from '../utils/utilities';
import Modal from 'rsuite/Modal';
import Input from 'rsuite/Input';
import QRTest, { getScanText } from './qRScanner';
import { MdOutlineAddCircleOutline as IconAdd } from 'react-icons/md';
import { COLOURS } from '../styles';
import { controller_t } from '../constants';
import { encode_mac_address, getModelTypeValueFromUID } from '../utils/uid';

export const AddDevice = ({ open, handleClose }) => {
  const [id, setId] = useState('');
  const [idValid, setIdValid] = useState(false);
  const [devType, setType] = useState(controller_t.NONE);
  const [textValue, setTextValue] = useState('');

  const [usersDevName, setUsersDevName] = useState('Unknown');

  const validateUsersName = (value) => {
    setUsersDevName(value);
    //setValid(checkUserNameValid(value));
  };

  const doValidateId = (value) => {
    if (value.length === 17) //UID
    {
      //Need to determine the type from the UID
      setType(getModelTypeValueFromUID(value).type);
    } else if (value.length === 12) // MAC address
    {
      //Convert value to MAC address.
      value = encode_mac_address(value, controller_t.AQUATEK);
    }

    // textValue (displayed) and id (submitted) must always be the same
    // final/normalized string, or the UI can keep showing an unencoded
    // 12-char MAC while Confirm silently submits the encoded value.
    setTextValue(value);
    setId(value);
    setIdValid(checkIdValid(value));
  };
  const validateId = (value) => {
    doValidateId(value);
  };

  const handleScan = (e) => {
    const scannedText = getScanText(e);
    if (scannedText === undefined) return;
    doValidateId(scannedText);
  };

  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Flex justifyContent="start" alignItems="center" className="space-x-1">
            <Icon icon={IconAdd} color={COLOURS.default} />
            <Subtitle color={COLOURS.default}>Add new controller</Subtitle>
          </Flex>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-2">
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>ID</span>
            <Input placeholder="Enter a valid ID" maxLength={17} size="sm" value={textValue} onChange={validateId} />
          </label>

          <QRTest onHandleScan={handleScan}></QRTest>

          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Custom User Name</span>
            <Input
              placeholder="Enter a valid name"
              maxLength={300}
              size="sm"
              value={usersDevName}
              onChange={validateUsersName}
            />
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex justifyContent="end" alignItems="center" className="space-x-2">
          <Button
            color={COLOURS.default}
            size="sm"
            onClick={() => handleClose({ id, devType, usersDevName })}
            disabled={!idValid}
          >
            Confirm
          </Button>
          <Button color={COLOURS.default} size="sm" variant="secondary" onClick={() => handleClose(null)}>
            Cancel
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
